<template>
	<div class="property-img">
		<img :src="url" alt="" />
	</div>
</template>

<script>
import api from "@/store/utils/api";
export default {
	name: "property-img",
	props: ["propertyId"],
	data() {
		return {
			url: "/img/garbur_property.png",
		};
	},
	async mounted() {
		const image = await api.get(`/api/v1/property/${this.propertyId}/image`);
		if (image) {
			this.url = image;
		}
	},
};
</script>

<style scoped lang="scss">
.property-img {
	height: 595px;
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}
</style>
